<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_OKPD_CLASS_ID'
        )
      }"
    >
      <p class="content-s-2-label"><label>Класс:</label></p>
      <select
        v-model="$parent.project.UF_OKPD_CLASS_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_OKPD_CLASS_ID'),
            changeClass()
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in directory.tree_sp_infoproduction"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.CODE + ' ' + item.NAME"
          v-if="
            isShowClassByProgram(item) &&
              (!isMarkingOnlyClassCode(item.CODE) ||
                $parent.$parent.getProgramCode() === 'lekarstva') &&
              ((item.CODE !== '8' &&
                item.CODE !== '38' &&
                $parent.$parent.getProgramCode() == 'lekarstva') ||
                (item.CODE !== 8 &&
                  (item.CODE !== '11' || isLizingSpecializedManufacturing()) &&
                  item.CODE !== '38' &&
                  item.CODE !== '19' &&
                  $parent.$parent.getProgramCode() != 'lekarstva'))
          "
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_OKPD_CLASS_ID"
          )
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_OKPD_PODCLASS_ID'
        )
      }"
    >
      <p class="content-s-2-label"><label>Подкласс:</label></p>
      <select
        v-model="$parent.project.UF_OKPD_PODCLASS_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_OKPD_PODCLASS_ID'
          ),
            changePodClass()
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in okpdPodclass"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-if="isShowPodClassByProgram(item)"
          v-text="item.CODE + ' ' + item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_OKPD_PODCLASS_ID"
          )
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_OKPD_GROUP_ID'
        )
      }"
    >
      <p class="content-s-2-label"><label>Группа:</label></p>
      <select
        v-model="$parent.project.UF_OKPD_GROUP_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_OKPD_GROUP_ID'),
            changeGroup()
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in okpdGroup"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.CODE + ' ' + item.NAME"
          v-if="isShowGroupClassByProgram(item)"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_OKPD_GROUP_ID"
          )
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_OKPD_PODGROUP_ID'
        )
      }"
    >
      <p class="content-s-2-label"><label>Подгруппа:</label></p>
      <select
        v-model="$parent.project.UF_OKPD_PODGROUP_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_OKPD_PODGROUP_ID'
          ),
            changePodGroup()
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in okpdPodGroup"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-if="isShowPodGroupClassByProgram(item)"
          v-text="item.CODE + ' ' + item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_OKPD_PODGROUP_ID"
          )
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_OKPD_VID_ID'
        )
      }"
    >
      <p class="content-s-2-label"><label>Вид:</label></p>
      <select
        v-model="$parent.project.UF_OKPD_VID_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_OKPD_VID_ID'),
            changeVid()
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in okpdVidclass"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-if="isShowVidClassByProgram(item)"
          v-text="item.CODE + ' ' + item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_OKPD_VID_ID")
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_OKPD_CATEGORY_ID'
        )
      }"
    >
      <p class="content-s-2-label"><label>Категория:</label></p>
      <select
        v-model="$parent.project.UF_OKPD_CATEGORY_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_OKPD_CATEGORY_ID'
          ),
            changeCategory()
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in okpdCategoryclass"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-if="isShowCategoriyaByProgram(item)"
          v-text="(item.CODE != 'no' ? item.CODE : '') + ' ' + item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_OKPD_CATEGORY_ID"
          )
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_OKPD_PODCATEGORY_ID'
        )
      }"
    >
      <p class="content-s-2-label"><label>Подкатегория:</label></p>
      <select
        v-model="$parent.project.UF_OKPD_PODCATEGORY_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_OKPD_VID_ID')
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in okpdPodCategoryclass"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="(item.CODE != 'no' ? item.CODE : '') + ' ' + item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_OKPD_PODCATEGORY_ID"
          )
        }}
      </div>
    </div>

    <!-- Таможенное наименование товара -->
    <div
      class="col-xs-12 mycol content-mb-14"
      v-if="
        $parent.project.UF_SETTING.VERSION_MARKER_PRODUCTS > 1 &&
          $parent.$parent.getProgramCode() === 'lekarstva' &&
          $parent.project.UF_MARKER_PRODUCTS_ID > 0
      "
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_TN_VED'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Таможенное наименование товара:</label>
      </p>
      <select
        v-model.trim="$parent.project.UF_TN_VED"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_TN_VED')
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in tnved()"
          v-bind:value="item.trim()"
          v-bind:key="item"
          v-text="item"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_OKPD_GROUP_ID"
          )
        }}
      </div>
    </div>
    <p
      class="content-info-text"
      v-show="$parent.$parent.getProgramCode() === 'konversia'"
    ></p>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "okpd",
  async created() {
    await this.$store.dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"]);
    await this.$store.dispatch(FETCH_DIRECTORY, ["tree/industry"]);
    await this.$store.dispatch(FETCH_DIRECTORY, [
      "sp_purchased_equipment_lizing"
    ]);
  },
  computed: {
    okpdPodclass() {
      if (this.project.UF_OKPD_CLASS_ID < 1) {
        return [];
      }
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.ID === this.$parent.project.UF_OKPD_CLASS_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdGroup() {
      if (this.project.UF_OKPD_PODCLASS_ID < 1) {
        return [];
      }
      let t = this.okpdPodclass.filter(
        c => c.ID === this.project.UF_OKPD_PODCLASS_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdPodGroup() {
      if (this.project.UF_OKPD_GROUP_ID < 1) {
        return [];
      }
      let t = this.okpdGroup.filter(
        c => c.ID === this.project.UF_OKPD_GROUP_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdVidclass() {
      if (this.project.UF_OKPD_PODGROUP_ID < 1) {
        return [];
      }
      let t = this.okpdPodGroup.filter(
        c => c.ID === this.project.UF_OKPD_PODGROUP_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdCategoryclass() {
      if (this.project.UF_OKPD_VID_ID < 1) {
        return [];
      }
      let t = this.okpdVidclass.filter(
        c => c.ID === this.project.UF_OKPD_VID_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdPodCategoryclass() {
      if (this.project.UF_OKPD_CATEGORY_ID < 1) {
        return [];
      }
      let t = this.okpdCategoryclass.filter(
        c => c.ID === this.project.UF_OKPD_CATEGORY_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    ...mapGetters(["directory", "project"])
  },
  methods: {
    tnved() {
      let t = this.directory.marker_products.filter(
        c => c.ID === this.$parent.project.UF_MARKER_PRODUCTS_ID
      );

      return t[0].TN_VED;
    },
    changeClass() {
      this.$parent.project.UF_OKPD_PODCLASS_ID = "";
      this.$parent.project.UF_OKPD_GROUP_ID = "";
      this.$parent.project.UF_OKPD_PODGROUP_ID = "";
      this.$parent.project.UF_OKPD_VID_ID = "";
      this.$parent.project.UF_OKPD_CATEGORY_ID = "";
      this.$parent.project.UF_OKPD_PODCATEGORY_ID = "";
    },
    changePodClass() {
      this.$parent.project.UF_OKPD_GROUP_ID = "";
      this.$parent.project.UF_OKPD_PODGROUP_ID = "";
      this.$parent.project.UF_OKPD_VID_ID = "";
      this.$parent.project.UF_OKPD_CATEGORY_ID = "";
      this.$parent.project.UF_OKPD_PODCATEGORY_ID = "";
    },
    changeGroup() {
      this.$parent.project.UF_OKPD_PODGROUP_ID = "";
      this.$parent.project.UF_OKPD_VID_ID = "";
      this.$parent.project.UF_OKPD_CATEGORY_ID = "";
      this.$parent.project.UF_OKPD_PODCATEGORY_ID = "";
    },
    changePodGroup() {
      this.$parent.project.UF_OKPD_VID_ID = "";
      this.$parent.project.UF_OKPD_CATEGORY_ID = "";
      this.$parent.project.UF_OKPD_PODCATEGORY_ID = "";
    },
    changeVid() {
      this.$parent.project.UF_OKPD_CATEGORY_ID = "";
      this.$parent.project.UF_OKPD_PODCATEGORY_ID = "";
    },
    changeCategory() {
      this.$parent.project.UF_OKPD_PODCATEGORY_ID = "";
    },
    isLizingSpecializedManufacturing() {
      if (
        this.$parent.$parent.getProgramCode() !== "lizing" ||
        !this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID ||
        this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID <= 0
      ) {
        return false;
      }
      let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
        c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
      );
      return (
        typeEqupment.length > 0 &&
        typeEqupment[0].CODE == "specialized_manufacturing_industries"
      );
    },
    isMachineToolDirection() {
      // Ограничение кодов продукции для программ "Проекты развития" (evolution)
      // и "Проекты РФРП / Проекты развития" (regfond) при направлении
      // финансирования "Производство станкоинструментальной продукции и роботов"
      let programCode = this.$parent.$parent.getProgramCode();
      if (programCode !== "evolution" && programCode !== "regfond") {
        return false;
      }
      if (
        !this.$parent.project.UF_DIRECTION_FINANCING_ID ||
        this.$parent.project.UF_DIRECTION_FINANCING_ID <= 0
      ) {
        return false;
      }
      let spDirectionFinanсing = this.directory.sp_direction_financing.filter(
        c => c.ID === this.$parent.project.UF_DIRECTION_FINANCING_ID
      );
      return (
        spDirectionFinanсing.length > 0 &&
        spDirectionFinanсing[0].CODE === "production_machine_tool_products_v2"
      );
    },
    isMachineToolOkpdAllowed(code) {
      // Разрешённые коды ОКПД для направления "Производство
      // станкоинструментальной продукции и роботов":
      //   25.73        — Инструмент
      //   26.51.66.190 — Инструменты, приборы и машины для измерения или
      //                  контроля прочие, не включенные в другие группировки
      //   28.4         — Оборудование металлообрабатывающее и станки
      //   28.99.39.200 — Промышленные роботы и робототехнические устройства
      // ОКПД2 — иерархия по цифровому префиксу (каждый уровень добавляет цифры),
      // поэтому сравниваем коды без разделителей. Показываем код, если он либо
      // предок разрешённого кода (путь к нему), либо его потомок (детализация).
      if (code === null || typeof code === "undefined") {
        return true;
      }
      let norm = String(code).replace(/\D/g, "");
      if (norm === "") {
        // узлы без кода (CODE === "no") — потомки уже отфильтрованного родителя
        return true;
      }
      let allowed = ["2573", "265166190", "284", "289939200"];
      return allowed.some(function(a) {
        return norm.indexOf(a) === 0 || a.indexOf(norm) === 0;
      });
    },
    isShowClassByProgram(item) {
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(item.CODE);
      }
      let isShowClass = false;
      let spDirectionFinanсing = [];
      if (this.$parent.project.UF_DIRECTION_FINANCING_ID &&
        this.$parent.project.UF_DIRECTION_FINANCING_ID > 0) {
        spDirectionFinanсing = this.directory.sp_direction_financing.filter(
          c => c.ID === this.$parent.project.UF_DIRECTION_FINANCING_ID
        );
      }

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        // 69413 ограничение только для профильных производств
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (typeEqupment[0].CODE == "specialized_manufacturing_industries") {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (this.in_array(indistry[0].CODE, [35])) {
            isShowClass = true;
          } else if (
            indistry[0].CODE.length > 2 &&
            indistry[0].CODE.indexOf(";", 0) >= 0
          ) {
            let arrCode = indistry[0].CODE.split(";");
            if (this.in_array(item.CODE, arrCode)) {
              isShowClass = true;
            }
          } else {
            let codeFind = indistry[0].CODE;
            if (indistry[0].CODE == 34) {
              codeFind = 32;
            } else if (indistry[0].CODE == "28_1") {
              codeFind = 28;
            } else if (indistry[0].CODE == "31_1") {
              codeFind = 31;
            } else if (indistry[0].CODE == "30_1") {
              codeFind = 30;
            } else if (indistry[0].CODE == 36) {
              codeFind = [10, 20];
            }

            if (Array.isArray(codeFind)) {
              if (this.in_array(item.CODE, codeFind)) {
                isShowClass = true;
              }
            } else if (item.CODE == codeFind) {
              isShowClass = true;
            }
          }
        } else {
          isShowClass = true;
        }
      } else if (
        this.$parent.project.UF_DIRECTION_FINANCING_ID &&
        this.$parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
        (this.$parent.$parent.getProgramCode() === "evolution" ||  this.$parent.$parent.getProgramCode() === "regfond")
      ) {
        if (
          spDirectionFinanсing.length > 0 &&
          spDirectionFinanсing[0].CODE &&
          spDirectionFinanсing[0].CODE == "modernization_ship_repair_enterprises") {
          if (item.CODE == 33) {
            isShowClass = true;
          }
        }else{
          isShowClass = true;
        }
      } else if (
        this.$parent.$parent.getProgramCode() !== "stankostroi" ||
        (this.$parent.$parent.getProgramCode() === "stankostroi" &&
          (item.CODE === 25 ||
            item.CODE === 26 ||
            item.CODE === 23 ||
            item.CODE === 28)
        )
      ) {
        isShowClass = true;
      }

      return isShowClass;
    },
    isShowPodClassByProgram(item) {
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(item.CODE);
      }
      let isShowPodClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        // 69413 ограничение только для профильных производств
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (typeEqupment[0].CODE == "specialized_manufacturing_industries") {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry[0].CODE == 34) {
            if (item.CODE == "32.5") {
              isShowPodClass = true;
            } else {
              isShowPodClass = false;
            }
          } else if (indistry[0].CODE == 36) {
            if (item.CODE == "10.8" || item.CODE == "20.1") {
              isShowPodClass = true;
            } else {
              isShowPodClass = false;
            }
          } else {
            isShowPodClass = true;
          }
        } else {
          isShowPodClass = true;
        }
      } else if (
        this.$parent.$parent.getProgramCode() != "stankostroi" ||
        (this.$parent.$parent.getProgramCode() === "stankostroi" &&
          (item.CODE === 28.4 ||
            item.CODE === 28.2 ||
            item.CODE === 25.7 ||
            item.CODE === 23.9 ||
            item.CODE === 26.5))
      ) {
        isShowPodClass = true;
      }
      return isShowPodClass;
    },
    isShowGroupClassByProgram(item) {
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(item.CODE);
      }
      let isShowGroupClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        // 69413 ограничение только для профильных производств
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (typeEqupment[0].CODE == "specialized_manufacturing_industries") {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry[0].CODE == 36) {
            if (
              item.CODE == "10.89" ||
              item.CODE == "10.86" ||
              item.CODE == "20.14"
            ) {
              isShowGroupClass = true;
            }
          } else {
            isShowGroupClass = true;
          }
        } else {
          isShowGroupClass = true;
        }
      } else {
        isShowGroupClass = true;
      }
      return isShowGroupClass;
    },
    isShowPodGroupClassByProgram(item) {
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(item.CODE);
      }
      let isShowPodGroupClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        // 69413 ограничение только для профильных производств
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (typeEqupment[0].CODE == "specialized_manufacturing_industries") {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry[0].CODE == 36) {
            if (
              item.CODE == "10.89.1" ||
              item.CODE == "10.86.1" ||
              item.CODE == "20.14.6"
            ) {
              isShowPodGroupClass = true;
            }
          } else {
            isShowPodGroupClass = true;
          }
        } else {
          isShowPodGroupClass = true;
        }
      } else {
        isShowPodGroupClass = true;
      }
      return isShowPodGroupClass;
    },
    isShowVidClassByProgram(item) {
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(item.CODE);
      }
      let isShowVidClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        // 69413 ограничение только для профильных производств
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (typeEqupment[0].CODE == "specialized_manufacturing_industries") {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry[0].CODE == 36) {
            if (
              item.CODE == "10.89.11" ||
              item.CODE == "10.89.19" ||
              item.CODE == "10.86.10" ||
              item.CODE == "20.14.64"
            ) {
              isShowVidClass = true;
            }
          } else {
            isShowVidClass = true;
          }
        } else {
          isShowVidClass = true;
        }
      } else {
        isShowVidClass = true;
      }
      return isShowVidClass;
    },
    isShowCategoriyaByProgram(item) {
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(item.CODE);
      }
      let isShowCategoriyaClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        // 69413 ограничение только для профильных производств
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (typeEqupment[0].CODE == "specialized_manufacturing_industries") {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry[0].CODE == 36) {
            let t = this.okpdVidclass.filter(
              c => c.ID === this.project.UF_OKPD_VID_ID
            );
            if (t.length > 0 && t[0].CODE == "10.89.19") {
              if (item.CODE == "10.89.19.160" || item.CODE == "10.89.19.210") {
                isShowCategoriyaClass = true;
              }
            } else {
              isShowCategoriyaClass = true;
            }
          } else {
            isShowCategoriyaClass = true;
          }
        } else {
          isShowCategoriyaClass = true;
        }
      } else {
        isShowCategoriyaClass = true;
      }
      return isShowCategoriyaClass;
    },
    in_array(idFind, a) {
      return a.filter(function(item) {
        return item == idFind;
      }).length
        ? true
        : false;
    },
    isMarkingOnlyClassCode(code) {
      // Коды первого уровня (класс) ОКПД, доступные только для программы
      // "Маркировка товаров" (внутренний код программы — "lekarstva"): 01, 03, 08.
      // Коды могут приходить числом/строкой/с ведущими нулями, поэтому
      // нормализуем к цифрам без ведущих нулей перед сравнением.
      let norm = String(code)
        .replace(/\D/g, "")
        .replace(/^0+/, "");
      return norm === "1" || norm === "3" || norm === "8";
    }
  }
};
</script>

<style scoped></style>
